import axios from 'axios'
import request from '@/utils/request'

// 获取列表数据
export async function api_getTableList(params) {
  return request({
    url: '/rest/store/page',
    method: 'get',
    params,
  })
}

// 修改门店状态
export async function api_putChangeStatus(params) {
  return request({
    url: '/rest/store/toggle',
    method: 'put',
    params,
  })
}

// 门店新增
export async function api_postShopAdd(data={}) {
  return request({
    url: '/rest/store',
    method: 'post',
    data,
  })
}

// 门店编辑
export async function api_putShopEdit(data={}) {
  return request({
    url: '/rest/store',
    method: 'put',
    data,
  })
}

// 门店详情
export async function api_getShopDetail(params) {
  return request({
    url: '/rest/store',
    method: 'get',
    params,
    loading: true,
  })
}

// 下载模板
export async function api_getShopTempDown(params) {
  return axios({
    url: '/rest/store/download/excel',
    method: 'get',
    params,
    responseType: 'blob',
    headers: { 'Content-Type': 'application/vnd.ms-excel' }
  })
}

// 批量添加店铺
export async function api_postShopBatchAdd(data) {
  return request({
    url: '/rest/store/batch',
    method: 'post',
    data,
  })
}

